// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-check.js';

import { paths } from '../generated/circle-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-check', Original, paths);
